import { Button } from '@mui/material';
import BaseTable from 'components/ui/tables/BaseTable';

import { memo, useState } from 'react';

import SimpleSearchInput from 'components/SearchInputNavbar';
import { useParams } from 'react-router-dom';

const WarehouseChecklistWithValue = () => {
  const { id } = useParams();
  const [refetch, setRefetch] = useState(false);
  const [open, setOpen] = useState(false);

  return (
    <div className='component-list-wrapper'>
      <div className='component-list-header mb-2'>
        <div className='header-actions-container py-3 flex flex-row items-center'>
          <div className='header-actions filter-box flex items-center px-4 w-full'>
            <Button
              variant='base'
              color='primary'
              startIcon={<i className='bi bi-filter' />}
              className='!mr-2'
            >
              Filter
            </Button>
            <SimpleSearchInput inputKey='name' />
          </div>
          <div className='header-actions action-buttons-box py-3 px-4 flex gap-2 items-center justify-center'>
            <Button
              variant='base'
              color='info'
              onClick={() => {
                setRefetch(true);
              }}
              disable={`${refetch}`}
            >
              <i
                className={`bi bi-arrow-repeat${
                  refetch ? ' animate-spin' : ''
                }`}
              />
            </Button>
            {/* <Button
              variant='base'
              color='success'
              className='!mx-2'
              onClick={() => setOpenStaffModal(true)}
            >
              <i className='bi bi-plus-circle' />
            </Button> */}
            <Button
              variant='base'
              color='default'
              onClick={() => setOpen(true)}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>

      <div className='component-table-wrapper h-[calc(100vh-180px)]'>
        <BaseTable
          emitRefetch={{ refetch, setRefetch }}
          emitTableColumns={{ open, setOpen }}
          dataPath={`admin/warehouses/getStockForecast/${id}`}
          tableName='admin/warehouses/getStockForecast/'
          headCells={[
            { code: 'product_name', label: 'Mahsulot nomi' },
            { code: 'current_stock', label: 'Hozir omborda mavjud' },
            {
              code: 'avg_daily_usage',
              label: "Kun davomida o'rtacha ishlatilishi",
            },
            { code: 'forecast_days_left', label: 'Tugash muddati' },
          ]}
          columns={[
            { code: 'product_name' },
            { code: 'current_stock' },
            { code: 'avg_daily_usage' },
            { code: 'forecast_days_left', type: 'forecastDaysLeft' },
          ]}
          noActions
        />
      </div>
    </div>
  );
};

export default memo(WarehouseChecklistWithValue);
